import { formatInt } from "@/lib/format";
import { usePlans } from "@/site/data";
import { membershipPlan } from "@/site/membership";

/** "₹4,999/month incl. GST" for the membership, read live from /platform/plans
 * (so an admin price change shows everywhere); null while unknown. */
export function useProPrice(): string | null {
  const plans = usePlans();
  const plan = membershipPlan(plans.data);
  return plan ? `₹${formatInt(plan.price_monthly)}/month incl. GST` : null;
}
